import { RunSchema } from '@/types/schema';

import { getInvocationParams } from './messages';

export const getModelNameFromRun = (run: RunSchema) => {
  const invocationParams = getInvocationParams(run);
  const metadata = run?.extra?.metadata;

  const model =
    metadata?.['ls_model_name'] ||
    invocationParams?.model?.info?.label || // specifically for Gemini models
    invocationParams?.model ||
    invocationParams?.model_name ||
    invocationParams?.model_id ||
    invocationParams?.model_path ||
    invocationParams?.endpoint_name;

  return model;
};
